export enum FeedbackRateEnum {
  DISLIKE = 0,
  LIKE = 1,
}

export enum FeedbackDefinitionName {
  LIKE_WITH_ACTION = "LikeWithAction",
  LIKE_BUT_NO_ACTION = "LikeButNoAction",
  LATE_RESPONSE = "LateResponse",
  INACCURATE_DATA = "InaccurateData",
  OTHER = "Other",
}
